import { useEffect, useRef } from 'react';

const POLL_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

export function useVersionCheck() {
  const currentVersion = useRef<string | null>(null);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return;
        const { version } = await res.json();

        if (currentVersion.current === null) {
          currentVersion.current = version;
          return;
        }

        if (currentVersion.current !== version) {
          window.location.reload();
        }
      } catch {
        // Network error — ignore, try again next interval
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        checkVersion();
      }
    };

    checkVersion();
    const interval = setInterval(checkVersion, POLL_INTERVAL_MS);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
}
